/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import { Grid, Row, Col } from 'react-bootstrap';
import Toolbar from 'loracoms/Toolbar';
import Nvl from 'loracoms/Nvl';
import PageLoading from 'loracoms/PageLoading';
import PageNoPerm from 'loracoms/PageNoPerm';
import IntlMsg from 'lorautils/intl/IntlMsg';
import SendBroadcast from './coms/SendBroadcast';
import AddrList from './coms/AddrList';
import Logs from './coms/Logs';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  pushState: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  appId: PropTypes.string.isRequired,
};

class BroadcastView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      plan: props.plan,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.broadcast');
  }

  componentWillReceiveProps(nextProps) {
    const { app, plan } = nextProps;
    this.setState({ app });
    if (!_.isEqual(plan, this.props.plan)) {
      this.setState({ plan });
    }
  }

  render() {
    const { appId } = this.props;
    const { app, plan: { data: { tier } = {}, status } } = this.state;
    const { data = {} } = app;

    const breadcrumb = [{
      onClick: () => this.props.pushState('/application'),
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
    }, {
      content: <Nvl val={data.name} status={app.status} />,
      active: true,
    }];

    if (status === 'pending') {
      return <PageLoading />;
    }
    if (tier === 1) {
      return <PageNoPerm />;
    }

    return (
      <div>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Toolbar breadcrumb={breadcrumb} />
            </Col>
          </Row>
          <Row className={styles.container}>
            <Col md={4}>
              <SendBroadcast appId={appId} />
            </Col>
            <Col md={8}>
              <AddrList appId={appId} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Logs appId={appId} />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

BroadcastView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  app: state.app.getApp,
  plan: state.billing.plan,
  appId: ownProps.params.id,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(BroadcastView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/BroadcastView/index.jsx